import React, { useEffect, useState } from 'react'
import { Card, CardContent } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import {
  CLAIMS_GRAPH_VIEW_TABS,
  menuOptionsPremiumAndClaims,
  PREMIUM_AND_CLAIMS_VIEW_TABS,
} from 'src/utils/constants/common'
import FinancialPremiumAndClaims from 'src/components/RiskReports/PremuimAndClaims/FinancialPremiumAndClaims'
import PremiumAndClaims from 'src/components/RiskReports/PremuimAndClaims/PremiumAndClaims'
import { addScroll, removeScroll } from 'src/utils/commonMethods'
import MenuIcon from '@mui/icons-material/Menu'
import LongMenu from 'src/components/common/Menu'

const PremiumAndClaimsView = ({
  data,
  chartHeight,
  series,
  categories,
  type,
  financialData,
  financialSeries,
}) => {
  const classes = useStyles()
  const [openMenu, setOpenMenu] = React.useState(null)
  const open = Boolean(openMenu)
  const [selectedView, setSelectedView] = useState(
    CLAIMS_GRAPH_VIEW_TABS?.PREMIUM
  )

  const handleClick = (event) => {
    setOpenMenu(event?.currentTarget)
  }

  const handleClose = () => {
    setOpenMenu(null)
  }

  const handleMenuOptionClick = (option) => {
    switch (option?.type) {
      case PREMIUM_AND_CLAIMS_VIEW_TABS?.FINANCIAL_PREMIUM_AND_CLAIMS_VIEW:
        setSelectedView(CLAIMS_GRAPH_VIEW_TABS?.FINANCIAL)
        break
      default:
        setSelectedView(CLAIMS_GRAPH_VIEW_TABS?.PREMIUM)
        break
    }
    handleClose()
  }

  useEffect(() => {
    if (openMenu) {
      removeScroll()
    } else {
      addScroll()
    }
  }, [openMenu])

  return (
    <div className='premiumAndClaimsParent'>
      <div className={classes.root}>
        <Card className={classes.cardContainer}>
          <CardContent>
            <div className={classes.menuIcon}>
              <MenuIcon id='Premium&claimsView' onClick={handleClick} />
              <LongMenu
                setOpenMenu={setOpenMenu}
                open={open}
                anchorEl={openMenu}
                options={menuOptionsPremiumAndClaims}
                handleClick={handleMenuOptionClick}
                handleClose={handleClose}
              />
            </div>
            {selectedView === CLAIMS_GRAPH_VIEW_TABS?.FINANCIAL && (
              <FinancialPremiumAndClaims
                data={financialData}
                chartHeight={chartHeight}
                series={financialSeries}
                categories={categories}
                type={type}
              />
            )}
            {selectedView === CLAIMS_GRAPH_VIEW_TABS?.PREMIUM && (
              <PremiumAndClaims
                data={data}
                chartHeight={chartHeight}
                series={series}
                categories={categories}
                type={type}
              />
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default PremiumAndClaimsView

const useStyles = makeStyles({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    borderRadius: '10px',
    textAlign: 'center',
  },
  title: {
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '22px',
    marginTop: '0px',
    padding: '0px 32px',
    color: '#333333',
    '& .MuiSelect-select': {
      padding: '0 14px 0 10px',
      fontWeight: 600,
      borderBottom: '1px solid #bbbbbb',
      borderRadius: 0,
    },
    '& fieldset': {
      border: '0px',
    },
  },
  menuItem: {
    paddingLeft: '16px',
    '&.MuiListItem-gutters': {
      paddingLeft: '16px !important',
    },
  },
  btnLabel: {
    textTransform: 'capitalize',
    color: '#02A9F4',
    textDecoration: 'underline',
    marginTop: '-15px',
  },
  modalContent: {
    textAlign: 'center',
    padding: '24px',
    height: 'calc(100% - 48px)',
    overflow: 'auto',
  },
  modalRoot: {
    height: '90%',
  },
  cardContainer: {
    borderRadius: '10px',
  },
  cardContentDiv: {
    display: 'flex',
    justifyContent: 'end',
    paddingTop: '15px',
  },
  premiumDiv: {
    cursor: 'pointer',
  },
  menuIcon: {
    display: 'flex',
    marginBottom: '-44px',
    cursor: 'pointer',
  },
})
